import { render, staticRenderFns } from "./MyHistory.vue?vue&type=template&id=b6a1d75c&scoped=true"
import script from "./MyHistory.vue?vue&type=script&lang=js"
export * from "./MyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a1d75c",
  null
  
)

export default component.exports